/* eslint-disable @angular-eslint/component-selector */
import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Icon } from '@malirang/front-share';

export type BottomSheetItem = {
  url: string;
  title: string;
  icon: string;
  mobileHidden?: boolean;
};

@Component({
  selector: 'app-bottom-sheet',
  templateUrl: './bottom-sheet.component.html',
  imports: [Icon, CommonModule, RouterLink, RouterLinkActive],
})
export class BottomSheetComponent {
  menus = input.required<BottomSheetItem[]>();

  currentMenus = computed(() =>
    this.menus().filter((menu) => !menu.mobileHidden),
  );
  menuClass = computed(
    () => `grid-cols-${this.currentMenus().length} grid items-center py-2`,
  );
}
